export default __webpack_public_path__ + "static/media/Dunedancer Shoes.6fdd5154.jpg";